











import * as CartBlocks from '@/views/cart/blocks'
import DkyTabs from './components/tabs.vue'
import {
  CartModel,
  cartModelProvider,
  getCartModel,
} from '@/views/cart/model'
import { defineClassComponent } from '@/hooks'
import {
  onActivated,
  onBeforeUnmount,
  onMounted,
  ref,
} from '@vue/composition-api'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: {
      DkyTabs,
      ...CartBlocks,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '购物车',
        }))

        // 提供购物车数据
        cartModelProvider.provide(this.cartModel as any)

        onMounted(async () => {
          // 获取购物车数据
          this.cartModel.value = (await getCartModel()) as any
          this.loading.value = false
        })

        onActivated(() => {
          // 刷新购物车数据
          this.cartModel.value.refresh?.()
        })

        onBeforeUnmount(() => {
          // 释放购物车数据
          this.cartModel.value.$destroy?.()
        })
      }

      // 是否加载中
      loading = ref(true)

      // 购物车数据
      cartModel = ref<CartModel>({} as any)
    },
)
